import { Component, OnInit, Input, EventEmitter, ViewChild } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { IstSummaryService } from 'src/app/services/ist/ist-summary.service';
import { departmentsOptionsConstant, currencyOptionsConstant, organisationType, organisationSubType, serviceConstants } from 'src/app/constants/service.constants';
import { Subject } from 'rxjs';
import { CommonService } from '../../../../services/common.service';
import * as $ from 'jquery';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DateObject, Document_Upload_File, SCREEN_CONTROL, SCREEN_RESPONSE, ScreenResponseModel } from 'src/app/models/common';
import { DatePipe } from '@angular/common';
import { FileService } from 'src/app/services/file.service';
import { EapSummaryService } from 'src/app/services/eap/eap-summary.service';
import { EAPDatashareService } from 'src/app/services/eap/eap-datashare.service';
import * as _ from 'lodash';

@Component({
  selector: 'app-eap-study-team-organization-view-modal',
  templateUrl: './eap-study-team-organization-view-modal.component.html',
  styleUrls: ['./eap-study-team-organization-view-modal.component.scss']
})
export class EapStudyTeamOrganizationViewModalComponent implements OnInit {
  @Input() public Content: any;
  formFields;
  departments = departmentsOptionsConstant;
  organisationType: any[];
  organisationSubType:any[];
  studyTeamOrganizationForm: UntypedFormGroup;
  ApplicationID: any;
  content: any;
  heading: string;
  action: Subject<any> = new Subject();
  staticformFields: any;
  appStatus: boolean = false;
  Application_Type_ID: string = "";
  IsFormToched: boolean = false;
  ModelData: any = null;
  submittedresponse: SCREEN_RESPONSE[] = [];
  tooltipValue: any;
  isDateModified: boolean = false;
  Full_Date: DateObject;
  genInfoFieldControls: any;
  currencyOptions = currencyOptionsConstant;
  SCREEN_MODEL: any = null;
  permission: string = "";
  screenCode: string = 'SCR-016';
  constructor(
    private summaryService: EapSummaryService,
    public modalRef: NgbActiveModal,
    public datashareService: EAPDatashareService,
    public commonService: CommonService,
    public datepipe: DatePipe,
    public fileService: FileService
  ) {
  }

    ngOnInit() {
      this.datashareService.ApplicationID.subscribe(x => {
        this.ApplicationID = x;
        this.GetScreenConfigControls(this.screenCode);
        if (!this.ApplicationID) {
          this.GetIstGenInfoScreenConfigControls();
        }
      });
      if (this.Application_Type_ID == null || this.Application_Type_ID == undefined || this.Application_Type_ID == "") {
        this.datashareService.Application_Type_ID.subscribe(x => {
          this.Application_Type_ID = x;
        });
      }
      this.appStatus = this.commonService.getIstStatus();
    }
  
    GetScreenConfigControls(screenCode: string) {
      this.commonService.GetScreenConfigControls(screenCode, this.ApplicationID, this.ApplicationID, (ScreenData) => {
        this.SCREEN_MODEL = ScreenData;
        this.staticformFields = ScreenData["SCREEN_CONTROL"];
        if (this.Content?.heading == "Edit" || this.Content?.heading == "View") {
          if (this.Content?.heading == "View") {
            this.permission = 'view';
          }
          this.getOrganizationData();
  
        }
      });
    }
  
    getOrganizationData() {
      this.summaryService.getSummaryData('api/EAPOrganization/Edit?RecordID=' + this.Content?.content?.id).subscribe(summary => {
        if (summary != null) {
          this.ModelData = summary;
          this.BindDataToDynamicControls();
          this.BindDataToStaticControls(summary);
        }
      });
    }
  
    BindDataToDynamicControls() {
      if (this.ApplicationID != null && this.ApplicationID != undefined && this.ApplicationID != "") {
        let sr = new ScreenResponseModel();
        sr.Id = this.screenCode;
        sr.RowId = this.Content?.content?.id;
        sr.AppId = this.ApplicationID;
        this.summaryService.getEAPScreenResponse(sr).subscribe(summary => {
          this.submittedresponse = summary;
          if (this.submittedresponse != null && this.submittedresponse.length > 0) {
            for (let i = 0; i < this.staticformFields?.length; i++) {
              let response = this.submittedresponse.filter(x => x.SCREEN_CONTROL_ID == this.staticformFields[i].ID);
  
              if (response != null && response.length > 0) {
                if (this.staticformFields[i].CONTROL == '6') {
                  if (response[0].SCREEN_RESPONSE_ANSWER[0].ANSWER != null && response[0].SCREEN_RESPONSE_ANSWER[0].ANSWER != undefined && response[0].SCREEN_RESPONSE_ANSWER[0].ANSWER != "") {
                    this.staticformFields[i].ControlValue = response[0].SCREEN_RESPONSE_ANSWER[0].ANSWER;
                    let options = response[0].SCREEN_RESPONSE_ANSWER[0].ANSWER.split(",");
                    if (this.staticformFields[i].SourceItems != null && this.staticformFields[i].SourceItems != undefined) {
                      for (let c = 0; c < this.staticformFields[i].SourceItems.length; c++) {
                        if (options.indexOf(this.staticformFields[i].SourceItems[c].value) > -1) {
                          this.staticformFields[i].SourceItems[c].Checked = true;
                        }
                        else {
                          this.staticformFields[i].SourceItems[c].Checked = false;
                        }
                      }
                    }
                  }
                }
                else if (this.staticformFields[i].CONTROL == '10') {
                  this.staticformFields[i].NotimesChanged = 0;
                  if (response[0].SCREEN_RESPONSE_ANSWER[0].ANSWER != null && response[0].SCREEN_RESPONSE_ANSWER[0].ANSWER != undefined && response[0].SCREEN_RESPONSE_ANSWER[0].ANSWER != "") {
                    this.staticformFields[i].ControlValue = [];
  
                    let options1 = response[0].SCREEN_RESPONSE_ANSWER[0].ANSWER.split(',');
                    options1.forEach((item) => {
                      this.staticformFields[i].ControlValue.push(item);
                    });
                    this.staticformFields[i].SUBFIELDNAME = response[0].SCREEN_RESPONSE_ANSWER[0].ANSWER;
                  }
                  else {
                    this.staticformFields[i].ControlValue = [];
                  }
                }
                else if (this.staticformFields[i].CONTROL == '5') {
                  if (response[0].SCREEN_RESPONSE_ANSWER[0].ANSWER != null && response[0].SCREEN_RESPONSE_ANSWER[0].ANSWER != "" && response[0].SCREEN_RESPONSE_ANSWER[0].ANSWER != undefined) {
                    let formd = new Date(response[0].SCREEN_RESPONSE_ANSWER[0].ANSWER);
                    this.staticformFields[i].ControlValue = formd;
                    if (this.staticformFields[i].DATEFORMATE == 'DD-MMM-YYYY') {
                      // let formd = this.datepipe.transform(new Date(response[0].SCREEN_RESPONSE_ANSWER[0].ANSWER), 'dd-MMM-yyyy');
                      let formd = this.commonService.getdisplayedDate(response[0].SCREEN_RESPONSE_ANSWER[0].ANSWER);
                      this.staticformFields[i].ControlValue = formd;
                    }
                  }
                }
                else {
                  this.staticformFields[i].ControlValue = response[0].SCREEN_RESPONSE_ANSWER[0].ANSWER;
                }
                this.staticformFields[i].UploadFiles = response[0].UploadFiles;
                if (this.staticformFields[i].CONTROL == '4') {
                  this.ApplyConditions({ value: this.staticformFields[i].ControlValue }, this.staticformFields[i], "N");
                }
              }
  
            }
          }
        });
      }
    }
  
    BindDataToStaticControls(MainObjData: any): any {
      for (var i = 0; i < this.staticformFields?.length; i++) {
        switch (this.staticformFields[i].FIELD_CODE) {
          case "NAME":
            this.staticformFields[i].ControlValue = MainObjData.NAME;
            break;
          case "TYPE":
            this.staticformFields[i].ControlValue = MainObjData.TYPE;
            break;
          case "SUB_TYPE":
            this.staticformFields[i].ControlValue = MainObjData.SUB_TYPE;
            break;
          case "WEB_SITE":
            this.staticformFields[i].ControlValue = MainObjData.WEB_SITE;
            break;
          case "ADDRESS":
            this.staticformFields[i].ControlValue = MainObjData.ADDRESS;
            break;
          case "PHONE":
            this.staticformFields[i].ControlValue = MainObjData.PHONE;
            break;
        }
  
        if (this.staticformFields[i].CONTROL == '4') {
          this.ApplyConditions({ value: this.staticformFields[i].ControlValue }, this.staticformFields[i], "N");
        }
      }
  
    }
    
    ApplyConditions($event, question, makeNull) {
        let value = $event.value;
        if (question.Control_Condtions == null || question.Control_Condtions == undefined) {
          question.Control_Condtions = [];
        }
        let displayControlIDS = [];
        let hideControlIDS = [];
        let enableControlIDS = [];
        let disbledControlIDS = [];
    
        question.Control_Condtions.forEach((item) => {
          if (item.Mapped_Control_Value == value) {
            item.ConditionsList.forEach((otemCon) => {
              switch (otemCon.Mapped_Condtion) {
                case "1": //display
                  if (displayControlIDS.length == 0) {
                    displayControlIDS = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
                  }
                  else {
                    let disCntrIds = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
                    if (disCntrIds && disCntrIds.length > 0) {
                      disCntrIds.forEach((id) => {
                        if (!displayControlIDS.includes(id)) {
                          displayControlIDS.push(id);
                        }
                      })
                    }
                  }
    
                  break;
                case "2": //enabled
                  if (enableControlIDS.length == 0) {
                    enableControlIDS = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
                  }
                  else {
                    let enableCntrIds = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
                    if (enableCntrIds && enableCntrIds.length > 0) {
                      enableCntrIds.forEach((id) => {
                        if (!enableControlIDS.includes(id)) {
                          enableControlIDS.push(id);
                        }
                      })
                    }
                  }
                  break;
                case "3": //hide
                  if (hideControlIDS.length == 0) {
                    hideControlIDS = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
                  }
                  else {
                    let hideCntrIds = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
                    if (hideCntrIds && hideCntrIds.length > 0) {
                      hideCntrIds.forEach((id) => {
                        if (!hideControlIDS.includes(id)) {
                          hideControlIDS.push(id);
                        }
                      })
                    }
                  }
    
                  break;
    
                case "4": //disabled
                  if (disbledControlIDS.length == 0) {
                    disbledControlIDS = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
                  }
                  else {
                    let disableCntrIds = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
                    if (disableCntrIds && disableCntrIds.length > 0) {
                      disableCntrIds.forEach((id) => {
                        if (!disbledControlIDS.includes(id)) {
                          disbledControlIDS.push(id);
                        }
                      })
                    }
                  }
                  break;
              }
    
            });
          }
        })
        //default
        if (value != "") {
          this.staticformFields.forEach((con) => {
    
            if (displayControlIDS.indexOf(con.ID) > -1) {
              con.IS_Dependent_Display = true;
              if (con.CONTROL == "4")
                this.UpdateParentChildDetails(con);
            }
            if (hideControlIDS.indexOf(con.ID) > -1) {
              con.IS_Dependent_Display = false;
              if (con.CONTROL == "4")
                this.UpdateParentChildDetails(con);
            }
            if (enableControlIDS.indexOf(con.ID) > -1) {
              con.IS_Dependent_Enabled = true;
              if (con.CONTROL == "4")
                this.UpdateParentChildDetails(con);
            }
            if (disbledControlIDS.indexOf(con.ID) > -1) {
              con.IS_Dependent_Enabled = false;
              if (con.CONTROL == "4")
                this.UpdateParentChildDetails(con);
            }
    
          });
        }
        else {
          this.UpdateParentChildDetails(question);
        }
    
        if (makeNull == "Y") {
          this.staticformFields.forEach((con) => {
            if (con.IS_Dependent_Display == false) {
              con.ControlValue = "";
              if (con.CONTROL == "10") {
                con.ControlValue = [];
              }
              if (con.CONTROL == "8") {
                con.UploadFiles.forEach((item) => {
                  item.Status = "Delete";
                });
              }
              if (con.CONTROL == "6") {
                con.SourceItems.forEach((item) => {
                  item.Checked = false;
                });
              }
            }
            if (con.IS_Dependent_Display == true) {
    
            }
            if (con.IS_Dependent_Enabled == false) {
              con.ControlValue = "";
              if (con.CONTROL == "10") {
                con.ControlValue = [];
              }
              if (con.CONTROL == "8") {
                con.UploadFiles.forEach((item) => {
                  item.Status = "Delete";
                });
              }
              if (con.CONTROL == "6") {
                con.SourceItems.forEach((item) => {
                  item.Checked = false;
                });
              }
            }
            if (con.IS_Dependent_Enabled == true) {
    
            }
          });
        }
      }
    
    
      UpdateParentChildDetails(question: any) {
        if (question.Control_Condtions == null || question.Control_Condtions == undefined) {
          question.Control_Condtions = [];
        }
        let displayControlIDS = [];
        let hideControlIDS = [];
        let enableControlIDS = [];
        let disbledControlIDS = [];
    
        question.Control_Condtions.forEach((item) => {
          item.ConditionsList.forEach((otemCon) => {
            switch (otemCon.Mapped_Condtion) {
              case "1": //display
                if (displayControlIDS.length == 0) {
                  displayControlIDS = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
                }
                else {
                  let disCntrIds = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
                  if (disCntrIds && disCntrIds.length > 0) {
                    disCntrIds.forEach((id) => {
                      if (!displayControlIDS.includes(id)) {
                        displayControlIDS.push(id);
                      }
                    })
                  }
                }
    
                break;
              case "2": //enabled
    
                if (enableControlIDS.length == 0) {
                  enableControlIDS = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
                }
                else {
                  let enableCntrIds = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
                  if (enableCntrIds && enableCntrIds.length > 0) {
                    enableCntrIds.forEach((id) => {
                      if (!enableControlIDS.includes(id)) {
                        enableControlIDS.push(id);
                      }
                    })
                  }
                }
                break;
              case "3": //hide
    
                if (hideControlIDS.length == 0) {
                  hideControlIDS = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
                }
                else {
                  let hideCntrIds = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
                  if (hideCntrIds && hideCntrIds.length > 0) {
                    hideCntrIds.forEach((id) => {
                      if (!hideControlIDS.includes(id)) {
                        hideControlIDS.push(id);
                      }
                    })
                  }
                }
                break;
    
              case "4": //disabled
                if (disbledControlIDS.length == 0) {
                  disbledControlIDS = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
                }
                else {
                  let disableCntrIds = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
                  if (disableCntrIds && disableCntrIds.length > 0) {
                    disableCntrIds.forEach((id) => {
                      if (!disbledControlIDS.includes(id)) {
                        disbledControlIDS.push(id);
                      }
                    })
                  }
                }
                break;
            }
          });
        })
        if (this.staticformFields) {
          this.staticformFields.forEach((con) => {
            if (displayControlIDS.indexOf(con.ID) > -1) {
              con.IS_Dependent_Display = false;
            }
            if (hideControlIDS.indexOf(con.ID) > -1) {
              con.IS_Dependent_Display = true;
            }
            if (enableControlIDS.indexOf(con.ID) > -1) {
              con.IS_Dependent_Enabled = false;
            }
            if (disbledControlIDS.indexOf(con.ID) > -1) {
              con.IS_Dependent_Enabled = true;
            }
          });
        }
      }
    
      SaveEAPOrganization() {
        if (this.validateControls()) {
          if (this.staticformFields != null && this.staticformFields.length > 0) {
            for (let i = 0; i < this.staticformFields.length; i++) {
              switch (this.staticformFields[i].CONTROL) {
                case 6:
                  let seletedItem = "";
                  for (let c = 0; c < this.staticformFields[i].SourceItems.length; c++) {
                    if (this.staticformFields[i].SourceItems[c].Checked == true) {
                      if (seletedItem == "")
                        seletedItem = this.staticformFields[i].SourceItems[c].value;
                      else
                        seletedItem = seletedItem + "," + this.staticformFields[i].SourceItems[c].value;
                    }
                  }
                  this.staticformFields[i].ANSWER = seletedItem;
                  break;
                case 8:
                  this.staticformFields[i].UploadedDocuments = [];
                  if (this.staticformFields[i].UploadFiles) {
                    for (let j = 0; j < this.staticformFields[i].UploadFiles.length; j++) {
                      if (this.staticformFields[i].UploadFiles[j].Status == "Add" || this.staticformFields[i].UploadFiles[j].Status == "Delete") {
                        this.staticformFields[i].UploadedDocuments.push(this.staticformFields[i].UploadFiles[j]);
                      }
                    }
                    this.staticformFields[i].ANSWER = null;
                    this.staticformFields[i].ControlValue = null;
                  }
                  break;
                case 10:
                  let SelectedValues = this.staticformFields[i].ControlValue;
                  if (SelectedValues != null && SelectedValues != undefined && SelectedValues.length > 0) {
                    this.staticformFields[i].ANSWER = SelectedValues.join(",");
                  }
                  else {
                    this.staticformFields[i].ANSWER = "";
                  }
                  this.staticformFields[i].SUBFIELDNAME = "";
                  //this.staticformFields[i].ControlValue = null;
                  break;
                case 5:
                  let controlanswer = this.staticformFields[i].ControlValue;
                  if (controlanswer != null && controlanswer != "" && controlanswer != undefined) {
                    let formd = this.datepipe.transform(new Date(controlanswer), 'dd-MMM-yyyy');
                    this.staticformFields[i].ANSWER = formd;
                  }
                  else {
                    this.staticformFields[i].ANSWER = controlanswer;
                  }
                  break;
                default:
                  this.staticformFields[i].ANSWER = this.staticformFields[i].ControlValue;
                  break;
              }
            }
    
            let uploadData = new FormData();
            if (this.Content?.heading == "Add") {
              if (!this.ApplicationID) {
                this.SaveEAP_GI_APP().subscribe((res) => {
                  if (res.Status === 0) {
                    this.ApplicationID = res["TransactionID"];
                    this.datashareService.setApplicationID(this.ApplicationID);
                    uploadData.append("Application_Type_ID", this.Application_Type_ID);
                    //uploadData.append("ScreenControlsData", JSON.stringify(this.staticformFields));
                    let FinalControls = _.cloneDeep(this.staticformFields);
                    FinalControls.forEach((item) => {
                      switch (item.CONTROL) {
                        case 10:
                          item.ControlValue = null;
                          break;
                      }
                    });
                    uploadData.append("ScreenControlsData", JSON.stringify(FinalControls));
                    uploadData.append("Appid", this.ApplicationID);
                    this.summaryService.SaveStudyTeamOrg("api/EAPOrganization/Insert", uploadData).subscribe((result) => {
                      this.IsFormToched = false;
                      if (result.Status === 0) {
                        this.commonService.SuccessBanner(result.Message);
                        this.commonService.refreshApplicationPage(this.ApplicationID, 'eap');
                        this.modalRef.close();
    
                      }
                      else {
                        this.commonService.ValidationBanner(result.Message);
                      }
                    });
                  }
                  else {
                    this.commonService.ValidationBanner(res.Message);
                  }
                })
              }
              else {
                //uploadData.append("ScreenControlsData", JSON.stringify(this.staticformFields));
                let FinalControls = _.cloneDeep(this.staticformFields);
                    FinalControls.forEach((item) => {
                      switch (item.CONTROL) {
                        case 10:
                          item.ControlValue = null;
                          break;
                      }
                    });
                uploadData.append("ScreenControlsData", JSON.stringify(FinalControls));
                uploadData.append("Appid", this.ApplicationID);
                uploadData.append("Application_Type_ID", this.Application_Type_ID);
                this.summaryService.SaveStudyTeamOrg("api/EAPOrganization/Insert", uploadData).subscribe((result) => {
                  this.IsFormToched = false;
                  if (result.Status === 0) {
                    this.modalRef.close();
                    this.commonService.SuccessBanner(result.Message);
                  }
                  else {
                    this.commonService.ValidationBanner(result.Message);
                  }
                });
              }
            }
            else {
              uploadData.append("ScreenControlsData", JSON.stringify(this.staticformFields));
              uploadData.append("Appid", this.ApplicationID);
              uploadData.append("ID", this.Content?.content?.id);
              let inactiveValueControls = this.commonService.checkInactiveRecordState(this.staticformFields);
              if (!inactiveValueControls || inactiveValueControls.length == 0) {
                this.summaryService.SaveStudyTeamOrg('api/EAPOrganization/Update', uploadData).subscribe(summary => {
                  if (summary.Status === 0) {
                    if (summary.ErrorCode === "NOCHANGES") {
                      this.getOrganizationData();
                      this.commonService.ValidationBanner(summary.Message);
                    }
                    else {
                      this.commonService.SuccessBanner(summary.Message);
                      this.modalRef.close();
                      this.Content.heading = "Edit";
                    }
                  }
                  else {
                    this.getOrganizationData();
                    this.commonService.ValidationBanner(summary.Message);
                  }
                });
              }
              else {
                let dataMsg = inactiveValueControls.join("</br>");
                this.commonService.ValidationBanner(dataMsg);
              }
            }
          }
        }
      }
    
      CancelPopUp() {
        this.modalRef.close();
      }
    
      keyPress(event: any) {
        const pattern = /[0-9\+\-\ ]/;
        let inputChar = String.fromCharCode(event.charCode);
        if (event.keyCode != 8 && !pattern.test(inputChar)) {
          event.preventDefault();
        }
      }
    
      validateControls(): boolean {
        let isValid = true;
        let message = "";
        this.staticformFields.forEach((item) => {
          if (item.IS_MANDATORY && item.IS_Dependent_Enabled == true && item.IS_Dependent_Display == true) {
            switch (item.CONTROL) {
              case 1:
                if (!item.ControlValue) {
                  $("#dynmcId" + item["ID"]).addClass("ng-touched ng-invalid validate-error");
                  $("#dynmcId" + item["ID"]).removeClass("ng-untouched ng-valid");
                  message += `Please enter ${item.LABEL} <br/>`;
                  isValid = false;
                }
                else {
                  if (item.FIELD_CODE == 'WEB_SITE') {
                    const website = '(https?://)?([\\da-z.-]+)\\.([a-z.]{2,6})[/\\w .-]*/?';
                    if (item.ControlValue.match(website)) {
                      $("#dynmcId" + item["ID"]).addClass("ng-untouched ng-valid");
                      $("#dynmcId" + item["ID"]).removeClass("ng-touched ng-invalid validate-error");
                    }
                    else {
                      $("#dynmcId" + item["ID"]).addClass("ng-touched ng-invalid validate-error");
                      $("#dynmcId" + item["ID"]).removeClass("ng-untouched ng-valid");
                      message += `Please enter valid ${item.LABEL} <br/>`;
                      isValid = false;
                    }
                  }
                  else if (item.FIELD_CODE == 'EMAIL') {
                    if (this.commonService.validateEmail(item.ControlValue)) {
                      $("#dynmcId" + item["ID"]).addClass("ng-untouched ng-valid");
                      $("#dynmcId" + item["ID"]).removeClass("ng-touched ng-invalid validate-error");
    
                    }
                    else {
                      $("#dynmcId" + item["ID"]).addClass("ng-touched ng-invalid validate-error");
                      $("#dynmcId" + item["ID"]).removeClass("ng-untouched ng-valid");
                      message += `Please enter valid ${item.LABEL} <br/>`;
                      isValid = false;
                    }
                  }
                }
                break;
              case 2:
              case 3:
              case 5:
              case 4:
              case 11:
                if (!item.ControlValue) {
                  $("#dynmcId" + item["ID"]).addClass("ng-touched ng-invalid validate-error");
                  $("#dynmcId" + item["ID"]).removeClass("ng-untouched ng-valid");
                  message += `Please enter ${item.LABEL} <br/>`;
                  isValid = false;
                }
                break;
              case 10:
    
                if (!(item.ControlValue) || (item.ControlValue != null && item.ControlValue.length == 0)) {
                  $("#dynmcId" + item["ID"]).addClass("ng-touched ng-invalid validate-error");
                  $("#dynmcId" + item["ID"]).removeClass("ng-untouched ng-valid");
                  message += `Please enter ${item.LABEL} <br/>`;
                  isValid = false;
                }
                break;
              case 6:
                let seletedItem = "";
                for (let c = 0; c < item.SourceItems.length; c++) {
                  if (item.SourceItems[c].Checked == true) {
                    if (seletedItem == "")
                      seletedItem = item.SourceItems[c].value;
                    else
                      seletedItem = seletedItem + "," + item.SourceItems[c].value;
                  }
                }
                item.ControlValue = seletedItem;
                if (!item.ControlValue) {
                  $("#dynmcId" + item["ID"]).addClass("ng-touched ng-invalid validate-error");
                  $("#dynmcId" + item["ID"]).removeClass("ng-untouched ng-valid");
                  message += `Please enter ${item.LABEL} <br/>`;
                  isValid = false;
                }
                break;
              case 7:
                if (!item.ControlValue) {
                  $("#dynmcId" + item["ID"]).addClass("ng-touched ng-invalid validate-error");
                  $("#dynmcId" + item["ID"]).removeClass("ng-untouched ng-valid");
                  message += `Please enter ${item.LABEL} <br/>`;
                  isValid = false;
                }
                break;
              case 8:
                if (item.UploadFiles != null && item.UploadFiles != undefined && item.UploadFiles.length == 0) {
                  $("#dynmcId" + item["ID"]).addClass("ng-touched ng-invalid validate-error");
                  $("#dynmcId" + item["ID"]).removeClass("ng-untouched ng-valid");
                  message += `Please enter ${item.LABEL} <br/>`;
                  isValid = false;
                }
                break;
              case 9:
                break;
            }
          }
          else {
            switch (item.CONTROL) {
              case 1:
                if (item.ControlValue) {
                  if (item.FIELD_CODE == 'WEB_SITE') {
                    const website = '(https?://)?([\\da-z.-]+)\\.([a-z.]{2,6})[/\\w .-]*/?';
                    if (item.ControlValue.match(website)) {
                      $("#dynmcId" + item["ID"]).addClass("ng-untouched ng-valid");
                      $("#dynmcId" + item["ID"]).removeClass("ng-touched ng-invalid validate-error");
                    }
                    else {
                      $("#dynmcId" + item["ID"]).addClass("ng-touched ng-invalid validate-error");
                      $("#dynmcId" + item["ID"]).removeClass("ng-untouched ng-valid");
                      message += `Please enter valid ${item.LABEL} <br/>`;
                      isValid = false;
                    }
                  }
                  else if (item.FIELD_CODE == 'EMAIL') {
                    if (this.commonService.validateEmail(item.ControlValue)) {
                      $("#dynmcId" + item["ID"]).addClass("ng-untouched ng-valid");
                      $("#dynmcId" + item["ID"]).removeClass("ng-touched ng-invalid validate-error");
    
                    }
                    else {
                      $("#dynmcId" + item["ID"]).addClass("ng-touched ng-invalid validate-error");
                      $("#dynmcId" + item["ID"]).removeClass("ng-untouched ng-valid");
                      message += `Please enter valid ${item.LABEL} <br/>`;
                      isValid = false;
                    }
                  }
                }
                break;
            }
          }
        });
    
        //Check atleast single field value exists
        if (isValid) {
          isValid = this.commonService.checkHasSingleControlValue(this.staticformFields);
          if (!isValid) {
            message += `Please enter atleast one field. <br/>`;
          }
        }
        if (!isValid)
          this.commonService.ValidationBanner(message);
        return isValid;
      }
    
      singleonChange($event, question) {
        this.IsFormToched = true;
        this.UpdateParentChildDetails(question);
        this.ApplyConditions($event, question, "Y");
      }
    
      DateSelect(event, question) {
        this.IsFormToched = true;
        this.isDateModified = true;
        this.Full_Date = {
          Day: event.getDate(),
          Month: (event.getMonth() + 1),
          Year: event.getFullYear(),
          Hours: 0,
          Minutes: 0,
          Seconds: 0,
          IsEndDate: false,
          HasValue: true,
          IsDateModified: this.isDateModified
        }
        question.dynamicDateobj = this.Full_Date;
      }
    
      ViewFile(fileID, fileName) {
        this.commonService.previewFile(fileID, fileName, "med");
      }
    
      isAllowedExtensionFile(Filename) {
        return this.commonService.isAllowedExtension(Filename);
      }
    
      uploadchange(event, ques: SCREEN_CONTROL): void {
        //let Flag = true;
        let Isexe = false;
        let Is5oMB = false;
        if (ques.UploadFiles == undefined || ques.UploadFiles == null)
          ques.UploadFiles = [];
        for (let i = 0; i < event.target.files.length; i++) {
          let uploadFile = new Document_Upload_File();
          let file = event.target.files[i].name;
          let ext = file.match(/\.([^\.]+)$/)[1];
          let filesize = event.target.files[i].size;
    
          if (file != null && (ext == 'exe')) {
            Isexe = true;        
          }
          else if (file != null && ((filesize > 52428800))) {
            Is5oMB = true;
          }
          else {
            this.saveTempFiles(event.target.files[i]).subscribe((result: any) => {
              let uploadFile = new Document_Upload_File();
              uploadFile.ID = result.Data[0].FileID;
              uploadFile.DOCUMENT_NAME = event.target.files[i].name;
              uploadFile.File = null;
              uploadFile.Status = "Add";
              uploadFile.UploadedDate = this.datepipe.transform(new Date().toUTCString(), 'dd-MMM-YYYY');
              let hasValue = ques.UploadFiles.filter(x => x.DOCUMENT_NAME.toLowerCase() == uploadFile.DOCUMENT_NAME.toLowerCase() && x.Status != "Delete");
              if (hasValue.length > 0) {
                this.commonService.ValidationBanner("File already exists with " + uploadFile.DOCUMENT_NAME + " Please update the unique file name");
              }
              else if (ques.ISALLOWMULTIPLEFILES) {
                ques.UploadFiles.push(uploadFile);
              } else {
                ques.UploadFiles.forEach((item) => {
                  item.Status = "Delete";
                })
                ques.UploadFiles.push(uploadFile);
              }
            });
    
          }
        }
       if (Is5oMB && Isexe) {
          this.commonService.ValidationBanner("The system does not support .exe files. Please choose a different file format to save the details and Accepts maximum file size 50MB");
        }
    
        else if (Is5oMB) {
          this.commonService.ValidationBanner("Accepts maximum file size 50MB");
        }
    
        else if (Isexe) {
          this.commonService.ValidationBanner("The system does not support .exe files. Please choose a different file format to save the details")
        }
        else {
    
        }
      }
    
      saveTempFiles(selectedFiles: any) {
        const formData = new FormData();
        formData.append(`files`, selectedFiles);
        return this.fileService.uploadMultiFiles(formData, "");
      }
    
      DeleteUpload(file, ques: SCREEN_CONTROL): void {
        this.IsFormToched = true;
        let code = file.ID;
        if (file.Status == "Add") {
          ques.UploadFiles = ques.UploadFiles.filter(function (sec) {
            return sec.ID != code;
          }, code);
        }
        else {
          this.commonService.CheckIsFileIsRefereancedInReviw(code).subscribe((x) => {
            if (x["Status"] == 2 && x["Data"] == false) {
              this.commonService.ValidationBanner(x["Message"]);
            }
            else {
              file.Status = "Delete";
            }
          });
        }
      }
    
      OpenFile(item: Document_Upload_File): void {
        if (item.Status == "Edit") {
          let Url = serviceConstants.apiURL + "api/screen/downloadfile/" + item.ID;
          window.open(Url);
        }
      }
    
      changeVal($event, question) {
        question.NotimesChanged = question.NotimesChanged + 1;
        question.IsTouched = true;
        if (question.NotimesChanged >= 2)
          this.IsFormToched = true;
    
        setTimeout(() => {
          let selectedControl = question.ControlValue;
          if (selectedControl != "" && selectedControl != undefined && selectedControl != null) {
            let controlLabel = question.SourceItems.filter((item) => {
              return selectedControl.indexOf(item.value) > -1;
            })
            let labellist = [];
            controlLabel.forEach((item) => {
              labellist.push(item.label);
            });
            this.tooltipValue = labellist.join(",");
          }
          else {
            this.tooltipValue = "";
          }
    
        }, 200);
    
      }
    
      SaveEAP_GI_APP() {
        let uploadData = new FormData();
        uploadData.append("ScreenControlsData", JSON.stringify(this.genInfoFieldControls));
        uploadData.append("Appid", '');
        uploadData.append("Application_Type_ID", this.Application_Type_ID);
        return this.summaryService.SaveEAPGeneralInfo("api/EAPGeneralInfo/Insert", uploadData);
      }
    
      GetIstGenInfoScreenConfigControls() {
        this.commonService.GetScreenConfigControls(this.screenCode, '', '', (ScreenData) => {
          this.genInfoFieldControls = ScreenData["SCREEN_CONTROL"];
        });
      }

}
